var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{staticClass:"w-full"},[_c('vs-alert',{staticClass:"text-center",attrs:{"active":"true","color":_vm.variant}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }